import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import InnerLoading from '../ui/InnerLoading'
import { CiLocationOn } from 'react-icons/ci'
import { FaCalendarAlt, FaStar } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { formatDateRange, getStatusClass } from '../../utils/data'
import { fetchBookTrips } from '../../features/home/bookTripSlice'


const BookedTrips = () => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { bookedTrips, loading } = useSelector((state: RootState) => state.bookingTripSlice)
    const { user } = useSelector((state: RootState) => state.user)

    useEffect(() => {
        if (user?.id) {
            dispatch(fetchBookTrips(user.id))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, user?.id])



    return (
        <>
            <h3 className='text-2xl font-semibold mb-4'>{t("my-bookings")}</h3>
            {loading ? (
                <InnerLoading />
            ) : bookedTrips.length === 0 ? (
                <div className="flex-center flex-col gap-3">
                    <div className="w-52">
                        <img
                            src="/asset/no-books.png"
                            className="w-full"
                            alt="no-books"
                            loading="lazy"
                        />
                    </div>
                    <p className="text-textSecond">{t('no-trips')}</p>
                </div>
            ) : (
                <div className="grid gap-4 xs:grid-cols-1 md:grid-cols-2">
                    {bookedTrips.map((booking, idx) => (
                        <Link
                            to={`/me/bookTrip-details/${booking.id}`}
                            key={idx}
                            className="flex w-full overflow-hidden rounded-2xl border shadow-sm bg-white"
                        >
                            <div className="relative xs:w-32 sm:w-40 overflow-hidden">
                                <img
                                    src={booking?.trip?.tripImages?.[0]?.url}
                                    alt={booking?.trip?.fromLocation} 
                                    className="w-full h-full object-cover"
                                />
                                <span
                                    className={`absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'
                                        } rounded-md bg-primary px-3 py-1 text-xs sm:text-sm text-white`}
                                >
                                    {booking?.trip?.subCategory?.title }
                                </span>
                            </div>
                            <div className="flex flex-col justify-between flex-1 p-3">
                                <div className="border-b pb-2">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-sm text-gray-600">
                                            <FaStar className="text-secondry" />
                                            {booking?.trip.rate?.toFixed(1)}{' '}
                                           
                                        </div>
                                        <span
                                            className={`xs:text-xs sm:text-sm font-medium ${getStatusClass(
                                                booking.state
                                            )}`}
                                        >
                                            {t(`status.${booking.state.toLowerCase()}`) || booking.state}
                                        </span>
                                    </div>
                                    <h2 className="mt-1 text-lg font-bold">
                                        {t("trip")} {booking.trip?.fromLocation} {t("to")} {booking.trip?.toLocation}
                                    </h2>
                                    <p className="flex items-center gap-1 text-sm text-gray-500">
                                        <CiLocationOn /> {booking?.trip.place?.title}
                                    </p>
                                    <p className="mt-1 text-lg font-semibold text-secondry">
                                        {booking?.price.toFixed(2)} {booking?.currency}
                                    </p>
                                </div>
                                <div className="flex-between pt-2 text-sm text-textSecond">
                                    <p className="flex items-center gap-1 text-darkColor font-medium">
                                        <FaCalendarAlt />
                                        <span>{t('dates')}</span>
                                    </p>
                                    <p>{formatDateRange(booking.trip.fromDate, booking.trip.toDate)}</p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

            )}
        </>
    )
}

export default BookedTrips

